import { collections } from '@modules/firebase';
import { toBBOrg } from '@modules/transformers';
import { assertIsType } from '@modules/types';
import { collection, doc, getDocs, onSnapshot } from 'firebase/firestore';
import type { BBOrg } from 'types';
import type { DBStripeSubscription } from 'types/db';

import { isDBBBOrg } from './predicates/org-predicates';

export function subscribeToOrg(userId: string, onUpdate: (org: BBOrg) => void): () => void {
  const bbOrgDocRef = doc(collections.bbOrgs(), userId);

  const unsubscribe = onSnapshot(bbOrgDocRef, async (bbOrgSnapshot) => {
    if (!bbOrgSnapshot.exists()) return;

    const subscriptionCollectionRef = collection(bbOrgSnapshot.ref, 'subscriptions');
    const subscriptionsSnapshot = await getDocs(subscriptionCollectionRef);

    const dbOrg = bbOrgSnapshot.data();
    const dbSubscriptions = subscriptionsSnapshot.docs.map((doc) => doc.data()) as DBStripeSubscription[];

    assertIsType(dbOrg, isDBBBOrg);

    onUpdate(toBBOrg(dbOrg, dbSubscriptions));
  });

  return unsubscribe;
}
